// Abonnements
export const ksDernierAbonnementQK = "dernier-abonnement";
export const ksHistoriqueAbonnementsQK = "historique-abonnements";
export const ksAllowReabonnementQK = "allow-reabonnement";
export const ksSabonnerDataQK = "sabonner-data";
// User
export const ksUserQK = "user";
// Assurances
export const ksHistoriqueAssurancesQK = "historique-assurances";
// Civilités
export const ksCivilitesQK = "civilites";
// Motifs support
export const ksMotifsSupportQK = "motifs-support";
// Factures
export const ksFacturesQK = "factures";
export const ksFacturesAPayerQK = "factures-a-payer";
// Attestations
export const ksAttestationsQK = "attestations";
// Produits
export const ksProduitsQK = "produits";
export const ksAchatsQK = "achats";
// Revues numériques
export const ksRevuesNumeriquesQK = "revues-numeriques";
// Petites annonces
export const ksPetitesAnnoncesQK = "petites-annonces";
// Webinaires
export const ksWebinairesQK = "webinaires";
